import { Dto, DtoWithId } from "@mango/core";
import { Groep } from "../enums/groep";
import { Rubriek } from "./rubriek";
import { Taal } from './taal';

@Dto({fullName: "CIJBorculo.Logic.Volgblad"})
export class Volgblad extends DtoWithId {
	oldID: number;
	file: string;
	omschrijving: string;
	groep: Groep;
	rubriek: Rubriek;
	taal: Taal;
	paginas: number;
	kolommen: number;
	actief: boolean;
}